module.exports = __webpack_public_path__ + "assets/img/lector-2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/lector-2.png
// module id = 1958
// module chunks = 0